// Landers Scripts

function scrollAbout() {
  document.getElementById('aboutTechScroll').scrollIntoView({ behavior: 'smooth' })
}

function scrollReviews() {
  document.getElementById('scrollSuccess').scrollIntoView({ behavior: 'smooth' })
}

function scrollFaq() {
  document.getElementById('faq').scrollIntoView({ behavior: 'smooth' })
}

function scrollBuy() {
  document.getElementById('buyPatch').scrollIntoView({ behavior: 'smooth' })
}

function answerOne() {
  var x = document.getElementById("one");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerTwo() {
  var x = document.getElementById("two");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerThree() {
  var x = document.getElementById("three");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerFour() {
  var x = document.getElementById("four");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerFive() {
  var x = document.getElementById("five");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerSix() {
  var x = document.getElementById("six");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerSeven() {
  var x = document.getElementById("seven");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerEight() {
  var x = document.getElementById("eight");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerNine() {
  var x = document.getElementById("nine");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerTen() {
  var x = document.getElementById("ten");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function answerEleven() {
  var x = document.getElementById("eleven");
  if (x.style.display != "block") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function scrollPatches() {
  document.getElementById('patchesGroup').scrollIntoView({ behavior: 'smooth' })
}
function scrollPatches() {
  document.getElementById('newPatchesGroup').scrollIntoView({ behavior: 'smooth' })
}

function scrollMobile() {
  document.getElementById('scrollMobile').scrollIntoView({ behavior: 'smooth' })
}


// cities toast
var cityNames = ["Aberdeen", "Abilene", "Akron", "Albany", "Albuquerque", "Alexandria", "Allentown", "Amarillo", "Anaheim", "Anchorage", 
                 "Ann Arbor", "Antioch", "Apple Valley", "Appleton", "Arlington", "Arvada", "Asheville", "Athens", "Atlanta", 
                 "Atlantic City", "Augusta", "Aurora", "Austin", "Bakersfield", "Baltimore", "Barnstable", "Baton Rouge", "Beaumont", 
                 "Bel Air", "Bellevue", "Berkeley", "Bethlehem", "Billings", "Birmingham", "Bloomington", "Boise", "Boise City", 
                 "Bonita Springs", "Boston", "Boulder", "Bradenton", "Bremerton", "Bridgeport", "Brighton", "Brownsville", "Bryan", 
                 "Buffalo", "Burbank", "Burlington", "Cambridge", "Canton", "Cape Coral", "Carrollton", "Cary", "Cathedral City", 
                 "Cedar Rapids", "Champaign", "Chandler", "Charleston", "Charlotte", "Chattanooga", "Chesapeake", "Chicago", "Chula Vista", 
                 "Cincinnati", "Clarke County", "Clarksville", "Clearwater", "Cleveland", "College Station", "Colorado Springs", "Columbia", 
                 "Columbus", "Concord", "Coral Springs", "Corona", "Corpus Christi", "Costa Mesa", "Dallas", "Daly City", "Danbury", 
                 "Davenport", "Davidson County", "Dayton", "Daytona Beach", "Deltona", "Denton", "Denver", "Des Moines", "Detroit", 
                 "Downey", "Duluth", "Durham", "El Monte", "El Paso", "Elizabeth", "Elk Grove", "Elkhart", "Erie", "Escondido", "Eugene", 
                 "Evansville", "Fairfield", "Fargo", "Fayetteville", "Fitchburg", "Flint", "Fontana", "Fort Collins", "Fort Lauderdale", 
                 "Fort Smith", "Fort Walton Beach", "Fort Wayne", "Fort Worth", "Frederick", "Fremont", "Fresno", "Fullerton", "Gainesville", 
                 "Garden Grove", "Garland", "Gastonia", "Gilbert", "Glendale", "Grand Prairie", "Grand Rapids", "Grayslake", "Green Bay", 
                 "GreenBay", "Greensboro", "Greenville", "Gulfport-Biloxi", "Hagerstown", "Hampton", "Harlingen", "Harrisburg", "Hartford", 
                 "Havre de Grace", "Hayward", "Hemet", "Henderson", "Hesperia", "Hialeah", "Hickory", "High Point", "Hollywood", "Honolulu", 
                 "Houma", "Houston", "Howell", "Huntington", "Huntington Beach", "Huntsville", "Independence", "Indianapolis", "Inglewood", 
                 "Irvine", "Irving", "Jackson", "Jacksonville", "Jefferson", "Jersey City", "Johnson City", "Joliet", "Kailua", "Kalamazoo", 
                 "Kaneohe", "Kansas City", "Kennewick", "Kenosha", "Killeen", "Kissimmee", "Knoxville", "Lacey", "Lafayette", "Lake Charles", 
                 "Lakeland", "Lakewood", "Lancaster", "Lansing", "Laredo", "Las Cruces", "Las Vegas", "Layton", "Leominster", "Lewisville", 
                 "Lexington", "Lincoln", "Little Rock", "Long Beach", "Lorain", "Los Angeles", "Louisville", "Lowell", "Lubbock", "Macon", 
                 "Madison", "Manchester", "Marina", "Marysville", "McAllen", "McHenry", "Medford", "Melbourne", "Memphis", "Merced", "Mesa", 
                 "Mesquite", "Miami", "Milwaukee", "Minneapolis", "Miramar", "Mission Viejo", "Mobile", "Modesto", "Monroe", "Monterey", 
                 "Montgomery", "Moreno Valley", "Murfreesboro", "Murrieta", "Muskegon", "Myrtle Beach", "Naperville", "Naples", "Nashua", 
                 "Nashville", "New Bedford", "New Haven", "New London", "New Orleans", "New York", "New York City", "Newark", "Newburgh", 
                 "Newport News", "Norfolk", "Normal", "Norman", "North Charleston", "North Las Vegas", "North Port", "Norwalk", "Norwich", 
                 "Oakland", "Ocala", "Oceanside", "Odessa", "Ogden", "Oklahoma City", "Olathe", "Olympia", "Omaha", "Ontario", "Orange", 
                 "Orem", "Orlando", "Overland Park", "Oxnard", "Palm Bay", "Palm Springs", "Palmdale", "Panama City", "Pasadena", "Paterson", 
                 "Pembroke Pines", "Pensacola", "Peoria", "Philadelphia", "Phoenix", "Pittsburgh", "Plano", "Pomona", "Pompano Beach", 
                 "Port Arthur", "Port Orange", "Port Saint Lucie", "Port St. Lucie", "Portland", "Portsmouth", "Poughkeepsie", "Providence", 
                 "Provo", "Pueblo", "Punta Gorda", "Racine", "Raleigh", "Rancho Cucamonga", "Reading", "Redding", "Reno", "Richland", 
                 "Richmond", "Richmond County", "Riverside", "Roanoke", "Rochester", "Rockford", "Roseville", "Round Lake Beach", 
                 "Sacramento", "Saginaw", "Saint Louis", "Saint Paul", "Saint Petersburg", "Salem", "Salinas", "Salt Lake City", 
                 "San Antonio", "San Bernardino", "San Buenaventura", "San Diego", "San Francisco", "San Jose", "Santa Ana", 
                 "Santa Barbara", "Santa Clara", "Santa Clarita", "Santa Cruz", "Santa Maria", "Santa Rosa", "Sarasota", "Savannah", 
                 "Scottsdale", "Scranton", "Seaside", "Seattle", "Sebastian", "Shreveport", "Simi Valley", "Sioux City", "Sioux Falls", 
                 "South Bend", "South Lyon", "Spartanburg", "Spokane", "Springdale", "Springfield", "St. Louis", "St. Paul", "St. Petersburg", 
                 "Stamford", "Sterling Heights", "Stockton", "Sunnyvale", "Syracuse", "Tacoma", "Tallahassee", "Tampa", "Temecula", "Tempe", 
                 "Thornton", "Thousand Oaks", "Toledo", "Topeka", "Torrance", "Trenton", "Tucson", "Tulsa", "Tuscaloosa", "Tyler", "Utica", 
                 "Vallejo", "Vancouver", "Vero Beach", "Victorville", "Virginia Beach", "Visalia", "Waco", "Warren", "Washington", 
                 "Waterbury", "Waterloo", "West Covina", "West Valley City", "Westminster", "Wichita", "Wilmington", "Winston", 
                 "Winter Haven", "Worcester", "Yakima", "Yonkers", "York", "Youngstown"];

window.onload = function() {
  function cityFunct() {
    var cityRandomNumber = Math.random() * (385 - 1 ) + 1;
    cityRandomNumber = parseInt(cityRandomNumber);
    var cityName = cityNames[cityRandomNumber];
    document.getElementById("cityId").innerHTML = cityName;
  }
  
  function randNum() {
    return Math.random() * (30 - 10) + 10;
  }

  var randomnumber = Math.floor(Math.random() * (30 - 10 + 1)) + 10;

  setInterval(function() {
    cityFunct();
    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
  }, randNum() * 1000)
};

// function startTimer(duration, display) {
//     var timer = duration, minutes, seconds;
//     setInterval(function () {
//         minutes = parseInt(timer / 60, 10);
//         seconds = parseInt(timer % 60, 10);

//         minutes = minutes < 10 ? "0" + minutes : minutes;
//         seconds = seconds < 10 ? "0" + seconds : seconds;

//         display.textContent = minutes + ":" + seconds;

//         if (--timer < 0) {
//             timer = duration;
//         }
//     }, 1000);
// }

// window.onload = function () {
//     var tenMinutes = 60 * 10,
//         display = document.querySelector('#time');
//     startTimer(tenMinutes, display);
// };


function showCheckoutBar() {
  var x = document.getElementById("showBar");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}


async function myFunction() {
  var popup = document.getElementById("closeX");
  document.getElementById("closeX").style.visibility = "visible";
}

function cartHop() {
  setTimeout(() => {
      location.href='/cart';
    }, 900);
}

function closeAd() {
  document.getElementById("closeCartAd").style.display = 'none';
}

function groupOne() {
  document.getElementById("patchColorGridOne").style.display = 'grid';
  document.getElementById("patchColorGridThree").style.display = 'none';
  document.getElementById("patchColorGridFive").style.display = 'none';
  document.getElementById("checkoutOneBlue").style.display = 'grid';
  document.getElementById("checkoutThreeBlue").style.display = 'none';
  document.getElementById("checkoutFiveBlue").style.display = 'none';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("patchColorGridOne").scrollIntoView({ behavior: 'smooth' });
  document.getElementById("totalDispB1").innerHTML = "$169.00";
  document.getElementById("totalDispW1").innerHTML = "$169.00";
  document.getElementById("b1Color").style.color = "black";
  document.getElementById("b1Color").style.border = "1px solid black";
  document.getElementById("w1Color").style.color = "#ccc";
  document.getElementById("w1Color").style.border = "1px solid #ccc";
}
function groupTwo() {
  document.getElementById("patchColorGridOne").style.display = 'none';
  document.getElementById("patchColorGridThree").style.display = 'grid';
  document.getElementById("patchColorGridFive").style.display = 'none';
  document.getElementById("checkoutOneBlue").style.display = 'none';
  document.getElementById("checkoutThreeBlue").style.display = 'grid';
  document.getElementById("checkoutFiveBlue").style.display = 'none';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("patchColorGridThree").scrollIntoView({ behavior: 'smooth' });
  document.getElementById("totalDispB3").innerHTML = "$249.99";
  document.getElementById("totalDispW3").innerHTML = "$249.99";
  document.getElementById("b3Color").style.color = "black";
  document.getElementById("b3Color").style.border = "1px solid black";
  document.getElementById("w3Color").style.color = "#ccc";
  document.getElementById("w3Color").style.border = "1px solid #ccc";
}
function groupThree() {
  document.getElementById("patchColorGridOne").style.display = 'none';
  document.getElementById("patchColorGridThree").style.display = 'none';
  document.getElementById("patchColorGridFive").style.display = 'grid';
  document.getElementById("checkoutOneBlue").style.display = 'none';
  document.getElementById("checkoutThreeBlue").style.display = 'none';
  document.getElementById("checkoutFiveBlue").style.display = 'grid';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("patchColorGridFive").scrollIntoView({ behavior: 'smooth' });
  document.getElementById("totalDispB5").innerHTML = "$357.00";
  document.getElementById("totalDispW5").innerHTML = "$357.00";
  document.getElementById("b5Color").style.color = "black";
  document.getElementById("b5Color").style.border = "1px solid black";
  document.getElementById("w5Color").style.color = "#ccc";
  document.getElementById("w5Color").style.border = "1px solid #ccc";
}

function b1() {
  document.getElementById("checkoutOneBlue").style.display = 'grid';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("b1Color").style.color = "black";
  document.getElementById("b1Color").style.border = "1px solid black";
  document.getElementById("w1Color").style.color = "#ccc";
  document.getElementById("w1Color").style.border = "1px solid #ccc";
}
function w1() {
  document.getElementById("checkoutOneWhite").style.display = 'grid';
  document.getElementById("checkoutOneBlue").style.display = 'none';
  document.getElementById("b1Color").style.color = "#ccc";
  document.getElementById("b1Color").style.border = "1px solid #ccc";
  document.getElementById("w1Color").style.color = "black";
  document.getElementById("w1Color").style.border = "1px solid black";
}
function b3() {
  document.getElementById("checkoutThreeBlue").style.display = 'grid';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("b3Color").style.color = "black";
  document.getElementById("b3Color").style.border = "1px solid black";
  document.getElementById("w3Color").style.color = "#ccc";
  document.getElementById("w3Color").style.border = "1px solid #ccc";
}
function w3() {
  document.getElementById("checkoutThreeBlue").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'grid';
  document.getElementById("b3Color").style.color = "#ccc";
  document.getElementById("b3Color").style.border = "1px solid #ccc";
  document.getElementById("w3Color").style.color = "black";
  document.getElementById("w3Color").style.border = "1px solid black";
}
function b5() {
  document.getElementById("checkoutFiveBlue").style.display = 'grid';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("b5Color").style.color = "black";
  document.getElementById("b5Color").style.border = "1px solid black";
  document.getElementById("w5Color").style.color = "#ccc";
  document.getElementById("w5Color").style.border = "1px solid #ccc";
}
function w5() {
  document.getElementById("checkoutFiveBlue").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'grid';
  document.getElementById("b5Color").style.color = "#ccc";
  document.getElementById("b5Color").style.border = "1px solid #ccc";
  document.getElementById("w5Color").style.color = "black";
  document.getElementById("w5Color").style.border = "1px solid black";
}

function blueBtn() {
//   document.getElementById("idkman2").style.display = 'block';
}
function checkOneB1() {
  document.getElementById("adBlock").style.display = 'block';
  document.getElementById("checkoutOneBlue").style.display = 'none';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("checkoutThreeBlue").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("checkoutFiveBlue").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("patchColorGridOne").style.display = 'none';
  document.getElementById("patchColorGridThree").style.display = 'none';
  document.getElementById("patchColorGridFive").style.display = 'none';
  document.getElementById("checkoutOneBlueTwo").style.display = 'grid';
  document.getElementById("checkoutOneWhiteTwo").style.display = 'none';
  document.getElementById("checkoutThreeBlueTwo").style.display = 'none';
  document.getElementById("checkoutThreeWhiteTwo").style.display = 'none';
  document.getElementById("checkoutFiveBlueTwo").style.display = 'none';
  document.getElementById("checkoutFiveWhiteTwo").style.display = 'none';
  document.getElementById("adBlock").scrollIntoView({ behavior: 'smooth' });
}
function checkOneW1() {
  document.getElementById("adBlock").style.display = 'block';
  document.getElementById("checkoutOneBlue").style.display = 'none';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("checkoutThreeBlue").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("checkoutFiveBlue").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("patchColorGridOne").style.display = 'none';
  document.getElementById("patchColorGridThree").style.display = 'none';
  document.getElementById("patchColorGridFive").style.display = 'none';
  document.getElementById("checkoutOneBlueTwo").style.display = 'none';
  document.getElementById("checkoutOneWhiteTwo").style.display = 'grid';
  document.getElementById("checkoutThreeBlueTwo").style.display = 'none';
  document.getElementById("checkoutThreeWhiteTwo").style.display = 'none';
  document.getElementById("checkoutFiveBlueTwo").style.display = 'none';
  document.getElementById("checkoutFiveWhiteTwo").style.display = 'none';
  document.getElementById("adBlock").scrollIntoView({ behavior: 'smooth' });
}
function checkOneB3(e) {
  document.getElementById("adBlock").style.display = 'block';
  document.getElementById("checkoutOneBlue").style.display = 'none';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("checkoutThreeBlue").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("checkoutFiveBlue").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("patchColorGridOne").style.display = 'none';
  document.getElementById("patchColorGridThree").style.display = 'none';
  document.getElementById("patchColorGridFive").style.display = 'none';
  document.getElementById("checkoutOneBlueTwo").style.display = 'none';
  document.getElementById("checkoutOneWhiteTwo").style.display = 'none';
  document.getElementById("checkoutThreeBlueTwo").style.display = 'grid';
  document.getElementById("checkoutThreeWhiteTwo").style.display = 'none';
  document.getElementById("checkoutFiveBlueTwo").style.display = 'none';
  document.getElementById("checkoutFiveWhiteTwo").style.display = 'none';
  document.getElementById("adBlock").scrollIntoView({ behavior: 'smooth' });
}
function checkOneW3() {
  document.getElementById("adBlock").style.display = 'block';
  document.getElementById("checkoutOneBlue").style.display = 'none';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("checkoutThreeBlue").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("checkoutFiveBlue").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("patchColorGridOne").style.display = 'none';
  document.getElementById("patchColorGridThree").style.display = 'none';
  document.getElementById("patchColorGridFive").style.display = 'none';
  document.getElementById("checkoutOneBlueTwo").style.display = 'none';
  document.getElementById("checkoutOneWhiteTwo").style.display = 'none';
  document.getElementById("checkoutThreeBlueTwo").style.display = 'none';
  document.getElementById("checkoutThreeWhiteTwo").style.display = 'grid';
  document.getElementById("checkoutFiveBlueTwo").style.display = 'none';
  document.getElementById("checkoutFiveWhiteTwo").style.display = 'none';
  document.getElementById("adBlock").scrollIntoView({ behavior: 'smooth' });
}
function checkOneB5() {
  document.getElementById("adBlock").style.display = 'block';
  document.getElementById("checkoutOneBlue").style.display = 'none';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("checkoutThreeBlue").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("checkoutFiveBlue").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("patchColorGridOne").style.display = 'none';
  document.getElementById("patchColorGridThree").style.display = 'none';
  document.getElementById("patchColorGridFive").style.display = 'none';
  document.getElementById("checkoutOneBlueTwo").style.display = 'none';
  document.getElementById("checkoutOneWhiteTwo").style.display = 'none';
  document.getElementById("checkoutThreeBlueTwo").style.display = 'none';
  document.getElementById("checkoutThreeWhiteTwo").style.display = 'none';
  document.getElementById("checkoutFiveBlueTwo").style.display = 'grid';
  document.getElementById("checkoutFiveWhiteTwo").style.display = 'none';
  document.getElementById("adBlock").scrollIntoView({ behavior: 'smooth' });
}
function checkOneW5() {
  document.getElementById("adBlock").style.display = 'block';
  document.getElementById("checkoutOneBlue").style.display = 'none';
  document.getElementById("checkoutOneWhite").style.display = 'none';
  document.getElementById("checkoutThreeBlue").style.display = 'none';
  document.getElementById("checkoutThreeWhite").style.display = 'none';
  document.getElementById("checkoutFiveBlue").style.display = 'none';
  document.getElementById("checkoutFiveWhite").style.display = 'none';
  document.getElementById("patchColorGridOne").style.display = 'none';
  document.getElementById("patchColorGridThree").style.display = 'none';
  document.getElementById("patchColorGridFive").style.display = 'none';
  document.getElementById("checkoutOneBlueTwo").style.display = 'none';
  document.getElementById("checkoutOneWhiteTwo").style.display = 'none';
  document.getElementById("checkoutThreeBlueTwo").style.display = 'none';
  document.getElementById("checkoutThreeWhiteTwo").style.display = 'none';
  document.getElementById("checkoutFiveBlueTwo").style.display = 'none';
  document.getElementById("checkoutFiveWhiteTwo").style.display = 'grid';
  document.getElementById("adBlock").scrollIntoView({ behavior: 'smooth' });
}

function gifClick() {
  document.getElementById("gifClick").style.display = 'none';
  // document.getElementById("dealio-hero-btn").style.display = 'none';
  document.getElementById("gifVideo").style.display = 'block';

  document.querySelectorAll(".ytvideo").forEach((el) => {
    el.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
  });

  if (ga != undefined) {
    ga('send', 'event', 'Videos', 'play', 'Landing Page Video Play');
  }

}

function gifClick2() {
  document.getElementById("gifClick2").style.display = 'none';
  
  document.getElementById("gifVideo2").style.display = 'block';
}
function goBack() {
  window.history.back();
}




// Add anchor links if id exists
// html format is
// <a data-anchorid="anchor-id" class="anchor-link"></a>
window.addEventListener("DOMContentLoaded", function() {
  
  var anchorLinks = document.querySelectorAll(".anchor-link");
  anchorLinks.forEach((el) => {
    let idlink = el.dataset.anchorid;
    if (document.getElementById(idlink) != undefined) {
      el.href="#" + idlink;
      console.log(el);
    } else {
      el.style.visibility = "hidden";
    }
  });
})

// var findFitEl = document.getElementById("find-your-fit");
// if (findFitEl != undefined) {
//   let p = document.createElement('p');
//   let a = document.createElement('a')
//   p.appendChild(a);
//   a.appendChild(document.createTextNode("Find Your Fit"))
//   a.href = "#find-your-fit";
//   a.classList.add("btn");
//   document.getElementById("relief-for-everybody");
//   document.getElementById('relief-for-everybody').appendChild(p);
// }